import { useRouter } from "next/router";
import { ErrorBoundaryProps } from "./ErrorBoundaryProps";
import ErrorLayout from "./ErrorLayout";
import ErrorIndicator from "./ErrorIndicator";
import Button from "components/elements/Button/Button";

export default function UnhandledExceptionError({
  onReset,
}: ErrorBoundaryProps) {
  const router = useRouter();

  async function onClickReturn() {
    await router.push("/");
    onReset?.();
  }

  return (
    <ErrorLayout>
      <div className="inline-block rounded bg-neutral-200 px-6 py-3 font-thin text-neutral-500">
        Application error
      </div>
      <h1 className="flex items-center text-4xl font-thin text-primary">
        <ErrorIndicator />
        There has been a problem that caused the application to crash.
      </h1>
      <p className="text-lg font-thin text-primary">
        We&apos;ve logged this incident to help us resolve the problem.
      </p>
      <Button type="button" theme="primary-solid" onClick={onClickReturn}>
        Return to Keyframe
      </Button>
    </ErrorLayout>
  );
}
